import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import axios from 'axios';
import GameProp from '../propTypes/gameProp';
import { compose, GAME_TYPE } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import Notifications from '../../../services/notifications';
import withCSRF from '../../../commonComponents/withCSRF';
import ConfirmScoreModal from './leaderboard/ConfirmScoreModal';
import LeaderboardList from './leaderboard/LeaderboardList';
import CurrencyProp from '../../profile/propTypes/currencyProp';

function Leaderboard({ t, _csrf, challenge, showNewScore, currencies }) {
  const [isModalShown, setIsModalShown] = useState(false);
  const showModal = () => setIsModalShown(true);
  const hideModal = () => setIsModalShown(false);

  const isProductivity =
    challenge.gameType && challenge.gameType.type === GAME_TYPE.PRODUCTIVITY;
  const isStatic = challenge.challenges && challenge.challenges.isStatic;
  const hasStarted = moment.utc(challenge.startDate).isBefore(moment.utc());
  const showScore = isProductivity && isStatic && hasStarted;

  const handleModalClose = (confirmed, isCustomScore, points) => {
    const params = {};
    if (isCustomScore && points) {
      params.points = parseFloat(points);
    } else if (isCustomScore && !points) {
      Notifications.showNotificationError(
        t('error'),
        t('challenge.score.custom'),
      );
      return;
    }

    hideModal();
    if (confirmed) {
      axios
        .post(`/api/game/${challenge._id}/score`, params, {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        })
        .then(() => {
          Notifications.showNotificationSuccess(
            t('success'),
            t('challengeDetails_scoreAdded'),
          );
          hideModal();
        })
        .catch(err => {
          Notifications.showErrorFromRequest(err, 'error_scoreAdd');
          console.log(err);
        });
    }
  };

  return (
    <>
      {isModalShown && (
        <ConfirmScoreModal
          onClose={handleModalClose}
          challenge={challenge}
          currencies={currencies}
        />
      )}
      <div className="m-portlet__body">
        {showScore && showNewScore && (
          <div className="table-add-button">
            <button
              type="button"
              onClick={showModal}
              className="btn btn-dynamic m-btn--pill m-btn--wide loader-button"
            >
              <i className="la la-plus" />
              {t('challengeDetails_newScore')}
            </button>
          </div>
        )}
        <LeaderboardList
          unity={challenge?.challenges?.unity || 'points'}
          challengeId={challenge._id}
          scoreTarget={
            challenge.challenges ? challenge.challenges.scoreTarget : 1
          }
        />
      </div>
    </>
  );
}

Leaderboard.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
  showNewScore: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
};

Leaderboard.defaultProps = {
  showNewScore: true,
};

export default compose(translate, withCSRF)(Leaderboard);
